import { vModelCheckbox as _vModelCheckbox, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "kw-selector" }
const _hoisted_2 = ["id", "disabled", "readonly"]
const _hoisted_3 = ["for"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { class: "kw-selector__tick" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      type: "checkbox",
      id: _ctx.inputId,
      disabled: _ctx.disabled,
      readonly: _ctx.readonly,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isChecked) = $event))
    }, null, 8, _hoisted_2), [
      [_vModelCheckbox, _ctx.isChecked]
    ]),
    _createElementVNode("label", {
      class: "kw-selector__label",
      for: _ctx.inputId
    }, [
      _hoisted_4,
      _createElementVNode("span", {
        class: _normalizeClass(["kw-selector__label-text", { 'sr-only': _ctx.hideLabel }])
      }, _toDisplayString(_ctx.label), 3)
    ], 8, _hoisted_3)
  ]))
}